import { VFC, useMemo } from 'react';
import { useIntl } from 'react-intl';
import { useMeterModelSuggestionsStore } from '../../../store/useMeterModelSuggestionsStore';
import { Select } from '../../Select/Select';
import { InputNumber } from '../../Input/InputNumber';
import { FormItem as messages } from '../messages';
import { getSelectOptionsWithSuggestions } from '../../Select/utils/getSelectOptionsWithSuggestions';

interface PulseRateSelectProps {
  value?: number | null;
  onChange?: (value: number | null) => void;
}

export const PulseRate: VFC<PulseRateSelectProps> = ({ ...restProps }) => {
  const intl = useIntl();
  const { meterModelSuggestions } = useMeterModelSuggestionsStore();

  const suggestedSelection = meterModelSuggestions?.pulse_rate?.selection as number[];

  const pulseRateOptions = useMemo(
    () =>
      getSelectOptionsWithSuggestions({
        intl,
        values: suggestedSelection,
        suggestedValue: meterModelSuggestions?.pulse_rate?.value,
        suggestedSelection,
      }),
    [intl, meterModelSuggestions, suggestedSelection],
  );

  const hasSuggestedSelection = suggestedSelection && suggestedSelection.length > 0;

  return hasSuggestedSelection ? (
    <Select showArrow className="w-100" options={pulseRateOptions} {...restProps} />
  ) : (
    <InputNumber
      placeholder={intl.formatMessage(messages.pulseRate)}
      step={1}
      style={{ width: '100%' }}
      {...restProps}
    />
  );
};
